import { JwtTokenInfo, LoginState } from "@/interfaces/sdk-login";
import { setTokenInfo } from "./types";

export default {
  [setTokenInfo](state: LoginState, parsedToken: JwtTokenInfo) {
    state.parsedToken = parsedToken;
  },
};
